import React from 'react'
import { Formik, Form } from 'formik'
import { FormikControl, ConsentMsg } from '..'
import * as Yup from 'yup'
import { NETLIFY_FUNCTIONS_PATH } from '../../../utils'
import { navigate } from 'gatsby'
import axios from 'axios'

const initialValues = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    location: '',
    description: '',
}

const contactSchema = Yup.object().shape({
    first_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    last_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    email: Yup.string().email('Invalid email').required('Required'),
    phone: Yup.string().min(15, 'Invalid phone number').required('Required'),
    location: Yup.string().required('Required'),
    description: Yup.string(),
})

export function ContactForm({ siteData }) {
    initialValues.location = siteData.currentMetro.stores[0].salesforceValue

    // Handle form submission
    const handleSubmit = async (values, helpers) => {
        try {
            helpers.setSubmitting(true)
            const formData = {
                ...values,
                updates: true,
                cloudamp__data__c: localStorage.getItem('cloudamp__data__c'),
                formType: 'contact',
            }
            await axios.post(`${NETLIFY_FUNCTIONS_PATH}form-handler`, formData)

            helpers.setSubmitting(false)
            helpers.setStatus('Success')

            // Reset form
            helpers.resetForm()
            navigate('/form/processing')
        } catch (error) {
            console.error('Form submission error:', error)
            helpers.setSubmitting(false)
            helpers.setStatus('Failed')
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={contactSchema}
            onSubmit={handleSubmit}
            validateOnChange={false}
        >
            {formik => {
                return (
                    <Form
                        id="contact-form"
                        className="w-100 pb-4"
                        method="POST"
                    >
                        <div className="row justify-content-center pt-md-2">
                            <div className="col-md-6 mb-3">
                                <FormikControl
                                    control="input"
                                    name="first_name"
                                    placeholder="First Name*"
                                    type="text"
                                    role="input"
                                    aria-required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <FormikControl
                                    control="input"
                                    name="last_name"
                                    placeholder="Last Name*"
                                    type="text"
                                    role="input"
                                    aria-required
                                />
                            </div>
                        </div>
                        <div className="row justify-content-center mx-auto gx-2">
                            <div className="col-md-6 mb-3">
                                <FormikControl
                                    control="phoneInput"
                                    name="phone"
                                    placeholder="Phone Number*"
                                    type="tel"
                                    role="input"
                                    aria-required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <FormikControl
                                    control="emailInput"
                                    name="email"
                                    placeholder="Your Email*"
                                    role="input"
                                    aria-required
                                />
                            </div>
                            <div className="mb-3">
                                <FormikControl
                                    control="selectLocation"
                                    id="location"
                                    name="location"
                                    title="Location"
                                    label="Location"
                                    milanStores={siteData.milanStores}
                                />
                            </div>
                        </div>
                        <div className="row justify-content-center overflow-hidden ">
                            <div className="mb-2">
                                <FormikControl
                                    control="textarea"
                                    name="description"
                                    placeholder="Hello..."
                                    rows="3"
                                    role="input"
                                />
                            </div>
                        </div>
                        <div className="row justify-content-center mb-3">
                            <div className="col-12 lh-1">
                                <ConsentMsg />
                            </div>
                        </div>

                        <div
                            id="actions-btns"
                            className="row justify-content-center mt-4"
                        >
                            <div className="col-10 col-lg-6 text-center">
                                <button
                                    className="milan-btn milan-red-btn w-100"
                                    type="submit"
                                    disabled={!formik.isValid}
                                >
                                    {formik.isSubmitting
                                        ? 'Submitting...'
                                        : 'Submit *'}
                                </button>
                            </div>
                        </div>
                    </Form>
                )
            }}
        </Formik>
    )
}

export default ContactForm
